import { ModalBase } from "./ModalBase";
import modalSize from "../../util/modalSizeEnum";

type ModalForcePartReceiveProps = {
	isOpen: boolean;
	buttonText: string;
	message: string;
	title: string;
	isFullyReceived?: boolean;
	onFinaliseSubmit?: () => void;
	onCancelFinalise?: () => void;
};
const partReceiveContextNew = {
	buttonText: "Yes",
	blurb: "There are still items that aren't fully received - are you expecting more shipments for this invoice?",
};

export default function ModalForcePartReceive(props: ModalForcePartReceiveProps) {
	const { isOpen, onFinaliseSubmit, onCancelFinalise, message, title } = props;

	const partReceiveContext = () => {
		return partReceiveContextNew;
	};

	return (
		<ModalBase
			isOpen={isOpen}
			message={message}
			primaryButtonName={partReceiveContext().buttonText}
			secondaryButtonName="No, go back"
			title={title}
			onPrimaryButtonClick={onFinaliseSubmit ? onFinaliseSubmit : () => {}}
			onSecondaryButtonClick={onCancelFinalise}
			size={modalSize.FULLSCREEN}
		/>
	);
}
